(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/helpers/statisticshelper.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/helpers/statisticshelper.js'); 
(function() {
  'use strict';

  var isServerSide = typeof exports === 'object';

  if (!isServerSide) {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    var getInverted = function(goalType, omitOwnGoal) {
      if (goalType === 2 && !omitOwnGoal) return 'f-red';
      return 'f-inverted';
    };

    hbs.registerHelper('formatResult', function(
      result,
      displayChange,
      optIn,
      goalType,
      omitOwnGoal
    ) {
      if (!result) {
        return new hbs.SafeString('');
      }
      var ret = '',
        resultStr = result.split('-'),
        i;
      resultStr.splice(1, 0, '-');
      if (optIn) {
        if (resultStr.length > 0) {
          for (i = 0; i < resultStr.length; i++) {
            ret +=
              '<span class="' +
              (resultStr[i] === '-'
                ? 'mid-padding-1 fc-sportservice-300'
                : '' || (i === 0 && displayChange.homeChange)
                ? getInverted(goalType, omitOwnGoal)
                : '' || (i === 2 && displayChange.awayChange)
                ? getInverted(goalType, omitOwnGoal)
                : 'fc-sportservice-300') +
              ' bold">';
            ret += resultStr[i] + '</span>';
          }
        }
      } else {
        if (resultStr.length > 0) {
          for (i = 0; i < resultStr.length; i++) {
            ret +=
              '<span class="' +
              (resultStr[i] === '-'
                ? 'mid-padding-1 fc-sportservice-300'
                : '' || (i === 0 && !displayChange.homeChange)
                ? 'fc-sportservice-300'
                : '' || (i === 2 && !displayChange.awayChange)
                ? 'fc-sportservice-300'
                : '') +
              ' bold">';
            ret += resultStr[i] + '</span>';
          }
        }
      }
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('ifOnlyOvertimePenaltyGoals', function(events, options) {
      if (!events && !events.length) {
        return false; 
      }

      var regularGoal = _.find(events, function(event) {
        return (
          event.time !== '-1'
        ); 
      });

      return regularGoal ? options.inverse(this) : options.fn(this);
    });

    hbs.registerHelper('winner', function(match) {
      var winner = '',
        intHomeResult,
        intAwayResult;

      if (isEnded(match.sport, match.status)) {
        try {
          var finalResult;
          if (match.result.find) {
            finalResult = match.result.find(function(result) {
              return result.isFinalResult;
            });
          } else {
            finalResult = _.findWhere(match.result, { isFinalResult: true });
          }
          if (finalResult) {
            intHomeResult = parseInt(finalResult.home, 10);
            intAwayResult = parseInt(finalResult.away, 10);
          } else {
            var winnerType = _.findWhere(match.result, { type: 15 });
            if (winnerType) {
              if (winnerType.home === 'W') {
                intHomeResult = 1;
                intAwayResult = 0;
              } else if (winnerType.away === 'W') {
                intHomeResult = 0;
                intAwayResult = 1;
              }
            }
          }
          if (isNaN(intHomeResult)) {
            intHomeResult = parseInt(match.homeTeam.result, 10);
            intAwayResult = parseInt(match.awayTeam.result, 10);
          }
          if (intHomeResult > intAwayResult) {
            winner += 'winner-home';
          } else if (intAwayResult > intHomeResult) {
            winner += 'winner-away';
          } else {
            winner += '';
          }
        } catch (e) {
        }
      }
      return new hbs.SafeString(winner);
    });

    hbs.registerHelper('showMatchStatistics', function(
      match,
      theSportId,
      periodResultText
    ) {
      var ret = '';

      function getOpenOddsetDraws(match) {
        if (_.isObject(match.oddsetDraws)) {
          var oddsetDrawsObj = match.oddsetDraws;
          if (_.isObject(oddsetDrawsObj)) {
            if (oddsetDrawsObj.drawState.toLowerCase() === 'open') {
              return true;
            }
          }
          return false;
        }
      }
      var resultClasses = '';
      if (svs.core.detect.formfactor.mobile()) {
        resultClasses += 'f-prominent';
      }
      var matchStatus = $.isNumeric(match.status)
        ? match.status
        : match.statusId;

      if (_.isString(periodResultText)) {
        return (ret +=
          '<div class="match-bottom-label align-center ' +
          resultClasses +
          '">' +
          periodResultText +
          '</div>');
      } else if (
        (matchStatus === 0 || getOpenOddsetDraws(match)) &&
        !isEnded(match.sport, matchStatus)
      ) {
        ret = getDisplayOdds(match, theSportId);
      } else if (
        !!((match || {}).league || {}).sport &&
        (matchStatus === 13 || isEnded(match.league.sport.id, matchStatus))
      ) {
        var resultStr = getTemplateFunction(
          'getThemedExtraResult',
          match.league.sport.id,
          match
        );

        if (resultStr) {
          var message = getTemplateFunction(
            'matchNotice',
            match.league.sport.id,
            match
          );

          if (
            getTemplateFunction(
              'isFullTimeOrPassed',
              match.league.sport.id,
              matchStatus,
              { includeFullTime: false }
            )
          ) {
            resultStr += _getFullTimeResult(match, resultStr);
          }

          if (message) {
            resultStr +=
              '<div class="match-bottom-label align-center ' +
              resultClasses +
              '"><strong>' +
              message +
              '</strong></div>';
          }

          return (ret +=
            '<div class="match-bottom-label align-center ' +
            resultClasses +
            '">' +
            resultStr +
            '</div>');
        }
        return (ret +=
          '<div class="match-bottom-label align-center ' +
          resultClasses +
          '"></div>');
      }
      return new hbs.SafeString(ret);
    });

    function _getFullTimeResult(match, resultStr) {
      var result = '',
        fullTimeResult = getTemplateFunction(
          'getFullTimeResult',
          match.league.sport.id,
          match
        );

      if (fullTimeResult && fullTimeResult.home && fullTimeResult.away) {
        if (resultStr.length > 10) {
          result += '<div class="full-time-result">';
        }

        result +=
          ' <strong>FT: ' +
          fullTimeResult.home +
          ' - ' +
          fullTimeResult.away +
          '</strong>';

        if (resultStr.length > 10) {
          result += '</div>';
        }
      }

      return result;
    }

    function getDisplayOdds(match, theSportId) {
      if (!isFullTimeOrPassed(match.sport, match.status)) {
        if (_.isObject(match.odds) && match.isShowOdds) {
          if (theSportId === svs.statistics.constants.TENNIS) {
            return (
              '<div class="match-bottom-label align-center f-prominent">(1:' +
              match.odds.one +
              ', 2:' +
              match.odds.two +
              ')</div>'
            );
          }
          return (
            '<div class="match-bottom-label align-center f-prominent">(1:' +
            match.odds.one +
            ', X:' +
            match.odds.x +
            ', 2:' +
            match.odds.two +
            ')</div>'
          );
        }
        return '<div class="match-bottom-label align-center f-prominent"></div>';
      }
    }

    hbs.registerHelper('ifShouldRenderLiveBarChart', function(
      statistic,
      options
    ) {
      if (
        _.contains(
          ['Räddningsprocent', 'Skott på mål', 'Missade skott'],
          statistic.name
        )
      ) {
        return options.inverse(this);
      }

      if (statistic.home === '0' && statistic.away === '0') {
        return options.inverse(this);
      }

      return options.fn(this);
    });

    hbs.registerHelper('renderLiveBarChart', function(home, away, percentage) {
      var ret = '',
        homeNumber = parseInt(home, 10),
        awayNumber = parseInt(away, 10),
        total = homeNumber + awayNumber,
        awayClass = 'less',
        homeClass = '',
        percentSign = '',
        homePercent = total === 0 ? 50 : Math.round((homeNumber / total) * 100),
        awayPercent = total === 0 ? 50 : 100 - homePercent;

      if (percentage) {
        percentSign = '%';
      }
      if (homePercent === 0 || awayPercent === 0) {
        ret += '<span class="chart spread-container span12 chart-bar-0">';
      } else {
        ret += '<span class="chart spread-container span12">';
      }
      ret += homePercent
        ? '<span class="home-label spread bar-home bar ' +
          homeClass +
          '" style="width:' +
          homePercent +
          '%;">' +
          home +
          percentSign +
          '</span>'
        : '<span class="home-label spread bar-home bar less' +
          homeClass +
          '" style="width:' +
          homePercent +
          '%;">' +
          home +
          percentSign +
          '</span>';
      ret += awayPercent
        ? '<span class="away-label spread bar-away bar ' +
          awayClass +
          '" style="width:' +
          awayPercent +
          '%;">' +
          away +
          percentSign +
          '</span>'
        : '<span class="away-label spread bar-away bar less' +
          awayClass +
          '" style="width:' +
          awayPercent +
          '%;">' +
          away +
          percentSign +
          '</span>';
      ret += '</span>';

      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('renderFavoritesWithLabels', function(
      favourite,
      homeTeam,
      awayTeam,
      showTie
    ) {
      var favouriteList = [
        Math.round(parseFloat(favourite.one)),
        Math.round(parseFloat(favourite.x)),
        Math.round(parseFloat(favourite.two))
      ];
      var ret = renderMutualsAsTables(
        favouriteList,
        homeTeam,
        awayTeam,
        '%',
        showTie
      );
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('renderChannelIcon', function(channel) {
      var channelName = channel.replace(/\s/g, '');
      channelName = channelName.replace('-', '');
      channelName =
        channelName.indexOf('.') > 0
          ? channelName.substring(0, channelName.indexOf('.'))
          : channelName;
      channelName = channelName.toLowerCase();
      var ret = hbs.partials['lb-ui-tv-tv']({
        name: channelName,
        title: channel,
        size: 16
      });
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('eventType', function(event) {
      var ret = '';
      if (event.type === 'card') {
        if (event.colour === 'Gult' || event.colour === 'Yellow') {
          ret += '<i class="yellow-card icon-default icon-card"></i>';
        } else if (event.colour === 'Gult/rött') {
          ret +=
            '<i class="yellow-card icon-default icon-card margin-card"></i>';
          ret += '<i class="red-card icon-default icon-card"></i>';
        } else {
          ret += '<i class="red-card icon-default icon-card"></i>';
        }
      } else if (event.type === 'goal') {
        var type = '';
        if (event.goalType === 2) {
          type = 'f-red';
        }
        var displayChange = event;
        if (_.isString(event.result)) {
          var resultStr = event.result.split('');
          if (resultStr.length > 0) {
            for (var i = 0; i < resultStr.length; i++) {
              ret +=
                '<span class="' +
                (resultStr[i] === '-'
                  ? 'mid-padding-1'
                  : '' || (i === 0 && displayChange.homeChange)
                  ? type + ' f-inverted bold'
                  : '' || (i === 2 && displayChange.awayChange)
                  ? type + ' f-inverted bold'
                  : '') +
                ' ">';
              ret += resultStr[i] + '</span>';
            }
          }
        }
      } else {
        ret += event.type;
      }
      return new hbs.SafeString(ret);
    });

    var displayWinLost = function(result, displayWin) {
      var score1 = result.substr(0, 1);
      var score2 = result.substr(result.length - 1, 1);
      var theScore = parseInt(score1, 10);

      if (displayWin) {
        if (score2 > theScore) {
          theScore = parseInt(score2, 10);
        }
      } else {
        if (score2 < theScore) {
          theScore = parseInt(score2, 10);
        }
      }
      return { theScore: theScore, score1: score1, score2: score2 };
    };

    hbs.registerHelper('displayWinLost', function(result, displayWin) {
      var ret = '';
      ret = displayWinLost(result, displayWin).theScore;
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('displayWinLostTeam', function(
      teamName,
      myTeamResult,
      otherTeamResult
    ) {
      var ret = '',
        displayWin = false;

      myTeamResult = myTeamResult === undefined ? '-' : myTeamResult;
      otherTeamResult = otherTeamResult === undefined ? '-' : otherTeamResult;

      if (myTeamResult > otherTeamResult) {
        displayWin = true;
      } else {
        displayWin = false;
      }

      if (displayWin) {
        ret += '<div class="left focus-label">' + teamName + '</div>';
        ret += '<div class="right focus-label">' + myTeamResult + '</div>';
      } else {
        ret += '<div class="left standard-label">' + teamName + '</div>';
        ret += '<div class="right standard-label">' + myTeamResult + '</div>';
      }

      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('markWinLostLabel', function(
      label,
      myTeamResult,
      otherTeamResult
    ) {
      var ret = '';

      myTeamResult = myTeamResult === undefined ? '-' : myTeamResult;
      otherTeamResult = otherTeamResult === undefined ? '-' : otherTeamResult;

      var displayWin = false;
      if (myTeamResult > otherTeamResult) {
        displayWin = true;
      } else {
        displayWin = false;
      }

      if (displayWin) {
        ret += '<span class="focus-label">' + label + '</span>';
      } else {
        ret += '<span class="standard-label">' + label + '</span>';
      }

      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('renderTrend', function(
      participants,
      isSingle,
      sizeLimit
    ) {
      var ret = '';

      if (!isSingle) {
        if (participants.length !== 2) {
          return '';
        }
      }
      for (var i = 0; i < participants.length; i++) {
        var participant = participants[i];

        if (_.isObject(participant)) {
          if (_.isObject(participant.latest)) {
            var maxLength = participant.latest.length;
            if (sizeLimit) {
              maxLength = sizeLimit;
              if (participant.latest.length < maxLength) {
                maxLength = participant.latest.length;
              }
            }

            ret += '<ul class="left trend-group">';
            if (i === 0) {
              if (participant.latest.length > maxLength) {
                ret += '<li class="left trend-bullet ">+</li>';
              }

              for (var j = maxLength - 1; j >= 0; j--) {
                ret +=
                  '<li class="left trend-bullet ' +
                  getClass(participant.latest[j]) +
                  '">' +
                  participant.latest[j] +
                  '</li>';
              }
              ret +=
                '<li class="left trend-bullet trend-arrow"><i class="icon-default ' +
                getIcon(participant.trend) +
                '"></i></li>';
            } else {
              ret +=
                '<li class="left trend-bullet trend-arrow"><i class="icon-default ' +
                getIcon(participant.trend) +
                '"></i></li>';
              for (var k = 0; k < maxLength; k++) {
                ret +=
                  '<li class="left trend-bullet ' +
                  getClass(participant.latest[k]) +
                  '">' +
                  participant.latest[k] +
                  '</li>';
              }

              if (participant.latest.length > maxLength) {
                ret += '<li class="left trend-bullet ">+</li>';
              }
            }
            ret += '</ul>';
            if (i === 0) {
              ret +=
                '<span class="left today f-uppercase f-condensed">Idag</span>';
            }
          }
        }
      }

      return new hbs.SafeString(ret);
    });

    function getClass(code) {
      if (code === 'F') {
        return 'trend-loss';
      } else if (code === 'V') {
        return 'trend-win';
      } else if (code === 'O') {
        return 'trend-tie';
      }
    }

    function getIcon(code) {
      if (code === -2) {
        return 'icon-form-negative f-red';
      } else if (code === -1) {
        return 'icon-form-down f-red';
      } else if (code === 0) {
        return 'icon-form-neutral f-yellow';
      } else if (code === 1) {
        return 'icon-form-up f-green';
      } else if (code === 2) {
        return 'icon-form-positive f-green';
      }
    }

    hbs.registerHelper('renderTrendIcon', function(data) {
      var ret = '';
      ret += '<i class="icon-default ' + getIcon(data.trend) + '"></i>';
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('renderHomeTeamTrend', function(participants) {
      var ret = '';
      for (var i = 0; i < participants.length; i++) {
        var participant = participants[i];
        ret += '<ul class="left trend-group">';

        if (i === 0) {
          for (var j = participant.latest.length - 1; j >= 0; j--) {
            ret +=
              '<li class="left trend-bullet ' +
              getClass(participant.latest[j]) +
              '">' +
              participant.latest[j] +
              '</li>';
          }
        }

        ret += '</ul>';
        if (i === 0) {
          ret +=
            '<span class="left today f-uppercase f-200 f-condensed">Idag</span>';
          ret +=
            '<span class="right trend-bullet trend-arrow"><i class="icon-default ' +
            getIcon(participant.trend) +
            '"></i></span>';
        }
      }
      return new hbs.SafeString(ret);
    });

    var renderMutualsAsTables = function(
      mutuals,
      homeTeam,
      awayTeam,
      label,
      showTie
    ) {
      var ret = '';
      var home = mutuals[0];
      var tie = mutuals[1];
      var away = mutuals[2];
      var total = home + tie + away;
      if (mutuals.length !== 3) {
        return ret;
      }

      if (label) {
        if (label.constructor === Object) {
          label = '';
        }
      }
      var widthOffset = 0;
      ret += '<table class="three-bars">';
      ret += '<tbody>';
      ret += '<tr>';
      ret +=
        '<td style="width:' +
        (getWidth(home, total) - widthOffset) +
        '%" class="three-bar home-label three-bar-dominant">' +
        home +
        label +
        '</li>';

      if (showTie !== false) {
        ret +=
          '<td style="width:' +
          (getWidth(tie, total) - widthOffset) +
          '%" class="three-bar tie-label three-bar-tie">' +
          tie +
          label +
          '</li>';
      }

      ret +=
        '<td style="width:' +
        (getWidth(away, total) + widthOffset) +
        '%" class="three-bar away-label">' +
        away +
        label +
        '</li>';
      ret += '</tr>';

      ret += '<tr>';
      ret +=
        '<td style="width:' +
        (getWidth(home, total) - widthOffset) +
        '%" class="home-label nowrap">' +
        homeTeam +
        '</li>';

      if (showTie !== false) {
        ret +=
          '<td style="width:' +
          (getWidth(tie, total) - widthOffset) +
          '%" class="tie-label nowrap">Oavg.</li>';
      }

      ret +=
        '<td style="width:' +
        (getWidth(away, total) + widthOffset) +
        '%" class="away-label nowrap">' +
        awayTeam +
        '</li>';
      ret += '</tr>';
      ret += '</tbody>';
      ret += '</table>';

      return new hbs.SafeString(ret);
    };

    hbs.registerHelper('renderMutualsAsTables', function(
      mutuals,
      homeTeam,
      awayTeam,
      label,
      showTie
    ) {
      var ret = renderMutualsAsTables(
        mutuals,
        homeTeam,
        awayTeam,
        label,
        showTie
      );
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('renderTransitionInfo', function(
      transitionInfo,
      transitionObject,
      showBox
    ) {
      var ret = JSON.stringify(transitionObject);

      var transitionName;
      if (transitionInfo && showBox) {
        transitionName = transitionInfo;
      }

      if (transitionObject && transitionName) {
        ret = 'stat-bg-color-' + transitionObject[transitionName].color;
      } else {
        ret = 'stat-bg-color-0';
      }
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('dynamictemplate', function(template, context) {
      var f;
      if (typeof template === 'function') {
        f = template;
      } else if (typeof template === 'string') {
        template = template.replace(/\//g, '_');
        f = hbs.partials[template];
        if (!f) {
          return 'Partial not loaded';
        }
      }
      return new Handlebars.SafeString(f(context));
    });

    hbs.registerHelper('renderTransitionLegend', function(transitionLegend) {
      var ret = '<div>';
      for (var i in transitionLegend) {
        if (transitionLegend[i].color !== 0) {
          ret +=
            '<div class="row"><div class="left table-league-legend-square stat-bg-color-' +
            transitionLegend[i].color +
            '">&nbsp;</div>' +
            '<div class="table-league-legend-text">' +
            i +
            '</div></div>';
        }
      }
      ret += '</div>';
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('renderTrendArrow', function(changeValue) {
      var ret = '';
      if (changeValue > 0) {
        ret +=
          '<i class="icon-default icon-ladder-up stat-trend-color-up"></i>';
      } else if (changeValue < 0) {
        ret +=
          '<i class="icon-default icon-ladder-down stat-trend-color-down"></i>';
      }
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('postponedMatch', function(matchStatus, options) {
      var result = false;
      if (
        (matchStatus && matchStatus === 24) ||
        (matchStatus && matchStatus === 23)
      ) {
        result = true;
      }
      if (result) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('isMatchFinished', function(sport, status, options) {
      var result = false;
      if (isEnded(sport, status)) {
        result = true;
      }

      if (result) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('isMatchNotFinished', function(sport, status, options) {
      if (!isEnded(sport, status)) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('checkForOwnGoal', function(
      goalType,
      team,
      homeTeam,
      awayTeam
    ) {
      var ret = '';

      if (goalType === 2) {
        if (team === homeTeam) {
          ret = awayTeam + '';
        } else if (team === awayTeam) {
          ret = homeTeam + '';
        }
      } else if (team) {
        ret = team;
      }
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('ordinalNumber', function(number) {
      var ret = '';

      if (number === 11 || number === 12) {
        ret = ':e';
      } else {
        var spill = number % 10;

        switch (spill) {
          case 1:
          case 2:
            ret = ':a';
            break;
          default:
            ret = ':e';
            break;
        }
      }

      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('lazy', function(match, options) {
      if (shouldHaveEnded(match)) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('formatedMatchResult', function(
      sportId,
      match,
      team,
      showHyphen
    ) {
      var result = getTemplateFunction(
        'formatedMatchResult',
        sportId,
        match,
        team,
        showHyphen
      );
      if (!result) {
        return new hbs.SafeString('&nbsp;');
      }
      return new hbs.SafeString(result);
    });

    hbs.registerHelper('hasResultOrLazy', function(
      sportId,
      match,
      isLazy,
      options
    ) {
      var result = getTemplateFunction(
        'hasResultOrLazy',
        sportId,
        match,
        isLazy
      );
      if (result) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('matchNotice', function(match) {
      var message = getTemplateFunction(
        'matchNotice',
        match.league.sport.id,
        match
      );
      if (message) {
        var ret = '<div class="left match-notice">';
        ret += message;
        ret += '</div>';
        return new hbs.SafeString(ret);
      }
    });

    hbs.registerHelper('formatedStartDate', function(match, displayText) {
      var ret = '';
      if (match) {
        var time = match.actualStartTime
          ? match.actualStartTime
          : match.startTime;
        ret = getDate(time, displayText);
      }
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('formatedTennisSet', function(pram, result) {
      if (pram === 8) {
        return 1;
      } else if (pram === 9) {
        return 2;
      } else if (pram === 10) {
        return 3;
      } else if (pram === 11) {
        return 4;
      } else if (pram === 12) {
        return 5;
      }
      if (result.length !== 0 && pram !== 27) {
        var score = _.findWhere(result, { type: 9 });
        if (_.isUndefined(score)) {
          return '-';
        }
        return parseInt(score.home, 10) + parseInt(score.away, 10);
      }
      return '-';
    });

    hbs.registerHelper('tennisIsLive', function(status) {
      var ret = ' spelade';
      if (
        status === 8 ||
        status === 9 ||
        status === 10 ||
        status === 11 ||
        status === 12 ||
        status === 13 ||
        status === 14 ||
        status === 27
      ) {
        ret = '';
      }
      return ret;
    });

    hbs.registerHelper('formatedTennisMatchTime', function(
      actualStartTime,
      startTime,
      status,
      statusTime
    ) {
      if (actualStartTime) {
        var diff;
        if (
          status === 41 ||
          status === 14 ||
          status === 26 ||
          status === 27 ||
          status === 28 ||
          status === 30 ||
          status === 31
        ) {
          diff =
            moment(actualStartTime).diff(moment(statusTime), 'minutes') * -1;
          return formatMinutesToHoursAndMinutes(diff);
        }
        diff = moment(actualStartTime).diff(moment(), 'minutes') * -1;
        return formatMinutesToHoursAndMinutes(diff);
      }
      return 0;
    });

    hbs.registerHelper('isSportWithSets', function(sportId, options) {
      if (isSportWithSets(sportId)) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('isSportWithTeams', function(sportId, options) {
      if (isSportWithTeams(sportId)) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    function isSportWithTeams(sportId) {
      return (
        sportId !== svs.statistics.constants.TENNIS &&
        sportId !== svs.statistics.constants.BADMINTON &&
        sportId !== svs.statistics.constants.TABLE_TENNIS
      );
    }

    function formatMinutesToHoursAndMinutes(diff) {
      var hours = Math.floor(diff / 60),
        minutes = diff % 60;
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      var result = hours + ':' + minutes;
      return result;
    }
    function getDate(time, displayText) {
      if (!window.moment || !time) {
        return '';
      }

      var diff,
        preStr = ': ',
        startTime = moment(time),
        simpleDate = startTime.format('D/M');

      if (displayText === true) {
        diff = Math.floor(
          startTime.diff(moment().startOf('day'), 'days', true)
        );

        if (diff > -1) {
          return '';
        } else if (diff === -1) {
          return preStr + 'Igår';
        } else if (diff < -1) {
          return preStr + simpleDate;
        }
        return '';
      }
      return simpleDate;
    }

    function getTemplateFunction(func, sport) {
      var returner = false,
        theme;
      var args = Array.prototype.slice.call(arguments, 0);
      args.splice(0, 2);
      theme = new svs.sport.themeLoader({
        sport: sport
      });
      theme.load(function(template, init) {
        if (init) {
          returner = init(func, args);
        }
      }, 'init');
      return returner;
    }

    function shouldHaveEnded(match) {
      return (
        !isEnded(match.league.sport.id, match.status) &&
        moment(match.startTime)
          .add(6, 'h')
          .diff(moment(), 'hours') < 0
      );
    }

    function isEnded(sport, status) {
      return getTemplateFunction('isEnded', sport, status);
    }

    function isSportWithSets(sportId) {
      return (
        sportId &&
        (sportId === svs.statistics.constants.TENNIS ||
          sportId === svs.statistics.constants.TABLE_TENNIS ||
          sportId === svs.statistics.constants.BADMINTON ||
          sportId === svs.statistics.constants.BEACH_VOLLEYBALL ||
          sportId === svs.statistics.constants.VOLLEYBALL)
      );
    }

    function getWidth(val, total) {
      return Math.round((val / total) * 100);
    }

    function isFullTimeOrPassed(sport, status) {
      return getTemplateFunction('isFullTimeOrPassed', sport, status);
    }
  }
})();

 })(window);